import { defaultThemeConfigWithBasicColors } from "@hopper-b2b/themes";
import { asB2BMuiTheme } from "@hopper-b2b/themes";

const uberColors = {
  ...defaultThemeConfigWithBasicColors,
  black: "#000000",
  grey: "#eeeeee",
  "black-disabled": "#afafaf",
  "black-hover": "#000000",
  "dark-grey": "#282828",
  green: "#009A51",
  yellow: "#F6BC2F",
  orange: "#E65300",
  red: "#F83446",
  blue: "#266ef1",
  "red-10": "#FFF0EE",
  "red-20": "#FFE1DE",
  "red-30": "#bb032a",
  "red-200": "#de1135",
  "grey-1000": "#f2f2f2",
  "grey-2000": "#f3f3f3",
  "grey-3000": "#5e5e5e",
  "grey-4000": "#4B4B4B",
  "grey-5000": "#a6a6a6",
  "grey-6000": "#545454",
  "grey-7000": "#727272",
  "grey-8000": "#E8E8E8",
  "blue-100": "#EFF3FE",
  "blue-200": "#D4E2FC",
  "blue-300": "#EFF4FE",
  "blue-400": "#276EF1",
  "blue-500": "#175bcc",
  "green-200": "#0e8345",
  "green-800": "#0D572D",
  "light-red": "#FC7F79",
  "light-orange": "#FFB48C",
  "light-yellow": "#FFD688",
  "lightest-yellow": "#fdf2dc",
  "light-green": "#7FD99A",
  "lightest-green": "#eaf6ed",
  "uber-spinner-blue": "#5b91f5",
  "yellow-2000": "#fbe5b6",
  "yellow-3000": "#845201",
  "text-primary": "#000000",
  "text-secondary": "#4B4B4B",
};
export const uberVariables = {
  ...uberColors,
  primary: uberColors["black"],
  "text-primary": uberColors["black"],
  "secondary-text": uberColors["grey-4000"],
  "text-secondary": uberColors["grey-4000"],
  "primary-disabled": "var(--black-disabled)",
  "primary-hover": "var(--black-hover)",
  "halfsheet-border-radius": "0.5rem 0.5rem 0 0",
  "mobile-banner": "var(--primary)",
  "loading-popup": "var(--white)",
  "link-text": "var(--primary)",
  "action-link-active-text": "var(--primary)",
  "hamburger-menu-color": "var(--white)",
  "filter-background-selected": "var(--grey)",
  "card-tag-text": "var(--green-800)",
  "card-tag-background": "var(--text-green-2-transparent)",
  "bucket-0-color": "var(--light-green)",
  "bucket-1-color": "var(--light-yellow)",
  "bucket-2-color": "var(--light-orange)",
  "bucket-3-color": "var(--light-red)",
  "inverse-text": "var(--white)",
  "input-label-text": "var(--grey-3000)",
  "red-error-color": "var(--red-200)",
  "card-border-color": "var(--grey-8000)",
  "card-border": "3px solid var(--card-border-color)",
  "price-freeze-card-color": "var(--blue-100)",
  "price-freeze-card-button": "var(--blue-200)",
  "price-freeze-tag": "var(--blue)",
  "success-color": "var(--green-200)",
  "pending-color": "var(--yellow)",
  "price-freeze-purchase-banner-background-color": "var(--blue-300)",
  "price-freeze-purchase-banner-text-color": "var(--primary)",
  "price-prediction-gradient-wait": "var(--light-red)",
  "price-prediction-gradient-fair": "var(--light-orange)",
  "price-prediction-gradient-good": "var(--light-yellow)",
  "price-prediction-gradient-great": "var(--light-green)",
  "spinner-border-color": "var(--grey)",
  "spinner-top-border-color": "var(--uber-spinner-blue)",
  "price-freeze-text": "var(--blue-400)",
  "date-hover-color": "transparent",
  "warning-error-color-transparent": "var(--lightest-yellow)",
  "disruption-background-color": "var(--lightest-green)",
  "fare-details-banner": "var(--primary)",
  "fare-details-banner-text": "var(--white)",
  "search-autocomplete-subheader-background": "var(--white)",
  "checkout-banner-background-color": "var(--blue-300)",
  "error-tag-color": "var(--red-30)",
  "error-tag-background-color": "var(--red-10)",
  "error-tag-border-color": "var(--red-20)",
  "notification-background-color": "var(--lightest-yellow)",
  "notification-border-color": "var(--yellow-2000)",
  "notification-text-color": "var(--yellow-3000)",
  "modal-box-shadow": "rgba(0, 0, 0, 0.12) 0px -4px 16px",
  // calendar
  "date-selected-color": "var(--primary)",
  "date-selected-text-color": "var(--white)",
  "date-text-color": "var(--primary)",
  // header
  "header-primary": "var(--primary)",
  "header-travel-destination": "var(--white)",
  "header-travel-passenger": "var(--grey-11)",
  // search
  "search-field-label": "var(--primary)",
  "search-field-text": "var(--secondary-text)",
  "info-details-popup-background": "none",
  "ftu-banner-background": "var(--lightest-green)",
  "pdp-banner-background": "var(--grey-2000)",
  "backdrop-shadow": "rgba(255, 255, 255, 0.6)",
  // Buttons
  "button-background": "var(--primary)",
  "button-background-disabled": "var(--primary-disabled)",
  "button-background-hover": "var(--primary-hover)",
  "button-border": "2px solid var(--primary)",
  "button-border-radius": "0.5rem",
  "button-box-shadow": "0px -4px 16px 0px rgba(0, 0, 0, 0.12)",
  "primary-button-font-color": "var(--white)",
  "primary-button-background": "var(--primary)",
  "secondary-button-font-color": "var(--primary)",
  "secondary-button-background": "var(--grey)",
  "large-button-padding": "1rem",
  "large-button-font-weight": "500",
  "large-button-font-size": "1.125rem",
  "ryanair-banner-color": "var(--blue-300)",
  "flight-review-card-border": "2px solid var(--grey-8000)",
  "fare-class-filter-border": "2px solid var(--grey-8000)",
  "fare-class-filter-border-radius": "2.25rem",
  "disabled-button-background": "var(--grey-2000)",
  "disabled-button-text": "var(--grey-5000)",
  "radio-button-border": "3px solid var(--grey-3000)",
  "radio-button-border-disabled": "var(--grey-8000)",
  "radio-button-border-selected": "7px solid var(--primary)",

  // VI
  "vi-banner-color": "var(--blue-300)",
  "vi-banner-text-color": "var(--blue-500)",
  "vi-banner-font-weight": "400",
  "vi-link": "var(--blue-400)",
  "self-transfer-disclaimer-background-color":
    "var(--warning-error-color-transparent)",
  "self-transfer-disclaimer-text-color": "var(--text-primary)",
  "multiple-airlines-banner-background-color":
    "var(--notification-background-color)",
  "multiple-airlines-banner-text-color": "var(--notification-text-color)",
  "multiple-airlines-banner-border-color": "var(--notification-border-color)",
};

const uberTheming = {
  palette: {
    type: "light" as any,
    primary: {
      light: "#01AAE4",
      main: "#01AAE4",
      contrastText: "#01AAE4",
    },
    secondary: {
      light: "#FA6866",
      main: "#FA6866",
      contrastText: "#FA6866",
    },
    text: {
      primary: "#505050",
      secondary: "#878787",
      disabled: uberVariables["primary-disabled"],
      hint: "#FFF",
    },
  },
  typography: {
    fontFamily: "Uber Move Text, sans-serif",
    htmlFontSize: 14,
    fontSize: 14,
    h1: {
      fontFamily: "Uber Move Text, sans-serif",
      fontSize: "2.5rem",
      fontWeight: 600,
      letterSpacing: 0,
    },
    h2: {
      fontFamily: "Uber Move Text, sans-serif",
      fontSize: "1.75rem",
      fontWeight: 600,
      letterSpacing: 0,
    },
    h3: {
      fontFamily: "Uber Move Text, sans-serif",
      fontSize: "1.5rem",
      fontWeight: 600,
      letterSpacing: 0,
    },
    h4: {
      fontFamily: "Uber Move Text, sans-serif",
      fontSize: "1.375rem",
      letterSpacing: 0,
    },
    h5: {
      fontFamily: "Uber Move Text, sans-serif",
      fontSize: "1.25rem",
      letterSpacing: 0,
    },
    h6: {
      fontFamily: "Uber Move Text, sans-serif",
      fontSize: "1rem",
      fontWeight: 600,
      letterSpacing: 0,
    },
    body1: {
      fontFamily: "Uber Move Text, sans-serif",
      fontSize: "1rem",
      letterSpacing: 0,
    },
    body2: {
      fontFamily: "Uber Move Text, sans-serif",
      fontSize: "1rem",
      letterSpacing: 0,
    },
    caption: {
      fontFamily: "Uber Move Text, sans-serif",
      fontSize: "0.875rem",
      letterSpacing: 0,
    },
    overline: {
      fontFamily: "Uber Move Text, sans-serif",
      fontSize: "1rem",
      letterSpacing: 0,
    },
    subtitle1: {
      fontFamily: "Uber Move Text, sans-serif",
      fontSize: "0.875rem",
      fontWeight: 600,
      letterSpacing: 0,
    },
    subtitle2: {
      fontFamily: "Uber Move Text, sans-serif",
      fontSize: "0.875rem",
      letterSpacing: 0,
    },
    button: {
      fontFamily: "Uber Move Text, sans-serif",
      fontSize: "1rem",
      lineHeight: "1.25rem",
      textTransform: "none" as const,
      letterSpacing: 0,
    },
  },
  overrides: {
    MuiLink: {
      root: {
        color: "#878787",
      },
      underlineHover: {
        "&:hover": {
          "text-decoration": "none",
        },
      },
    },
    MuiButton: {
      root: {
        "&:hover": {
          backgroundColor: "black",
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            backgroundColor: "black",
          },
        },
      },
      contained: {
        "&:hover": {
          backgroundColor: "black",
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            backgroundColor: "black",
          },
        },
      },
    },
    MuiAlert: {
      root: {
        borderRadius: 12,
        fontWeight: 500,
      },
      standardSuccess: {
        backgroundColor: uberColors["dark-grey"],
        color: uberColors.white,
      },
      standardWarning: {
        backgroundColor: uberColors["dark-grey"],
        color: uberColors.white,
      },
      standardError: {
        backgroundColor: uberColors["dark-grey"],
        color: uberColors.white,
      },
      icon: {
        color: `${uberColors.white} !important`,
      },
    },
  },
};

export const muiTheme = asB2BMuiTheme(uberTheming);
